document.addEventListener('DOMContentLoaded', function () {
	const form = document.getElementById('newsletter-form-ajax');
	const fullform = document.getElementById('newsletter-block');
	const responseContainer = document.getElementById('newsletter-response');
	if (form && responseContainer) {
		const submitButton = form.querySelector('input[type="submit"]');
		form.addEventListener('submit', function (e) {
			e.preventDefault();

			const emailInput = document.getElementById('newsletter-email');
			const email = emailInput.value;
			const nonceInput = document.getElementById('newsletter-nonce');
			const nonce = nonceInput.value;

			// Create a new XMLHttpRequest object
			const xhr = new XMLHttpRequest();

			// Set up the AJAX request
			xhr.open('POST', newsletterobject.ajaxurl, true); //eslint-disable-line
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

			// Handle the AJAX response
			xhr.onload = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					const response = JSON.parse(xhr.responseText);
					const successMessage = document.createElement('p');
					successMessage.className = 'newsletter-success p2';
					const errorMessage = document.createElement('p');
					errorMessage.className = 'newsletter-error p2';
					const errorDiv = document.getElementsByClassName('newsletter-error');
					if (response.success === true) {
						if (errorDiv[0]) {
							errorDiv[0].remove();
						}
						responseContainer.classList.remove('newsletter-error');
						// Create the success icon image
						const successIcon = document.createElement('img');
						successIcon.setAttribute(
							'src',
							'./wp-content/client-mu-plugins/ib-newsletter-signup/dist/static/assets/icon-checkmark.svg',
						);
						successIcon.setAttribute('alt', 'Success Icon');
						// Append the success icon to the success message
						successMessage.appendChild(successIcon);
						const messageText = document.createTextNode(response.data.message);
						successMessage.appendChild(messageText);
						if (
							fullform.getElementsByClassName('p2') !== null &&
							!fullform.getElementsByClassName('p2')
						) {
							fullform.getElementsByClassName('p2')[0].style.display = 'none';
						}
						form.style.display = 'none';
						responseContainer.insertAdjacentElement('afterbegin', successMessage);
						// Disable the submit button
						submitButton.disabled = true;
						// Reset the form
						form.reset();
					} else if (response.success === false) {
						if (errorDiv[0]) {
							errorDiv[0].remove();
						}
						responseContainer.classList.remove('newsletter-error');
						// Create the success icon image
						const successIcon = document.createElement('img');
						successIcon.setAttribute(
							'src',
							'./wp-content/client-mu-plugins/ib-newsletter-signup/dist/static/assets/icon-checkmark.svg',
						);
						successIcon.setAttribute('alt', 'Success Icon');
						// Append the success icon to the success message
						successMessage.appendChild(successIcon);
						const messageText = document.createTextNode(response.data.message);
						successMessage.appendChild(messageText);
						if (
							fullform.getElementsByClassName('p2') !== null &&
							!fullform.getElementsByClassName('p2')
						) {
							fullform.getElementsByClassName('p2')[0].style.display = 'none';
						}
						form.style.display = 'none';
						responseContainer.insertAdjacentElement('afterbegin', successMessage);
						// Disable the submit button
						submitButton.disabled = true;
						// Reset the form
						form.reset();
					} else {
						if (errorDiv[0]) {
							errorDiv[0].remove();
						}
						const messageText = document.createTextNode(response.data.message);
						errorMessage.appendChild(messageText);
						responseContainer.insertAdjacentElement('afterbegin', errorMessage);
					}
				}
			};

			// Send the AJAX request
			xhr.send(`action=newsletter_signup&email=${email}&nonce=${nonce}`); //eslint-disable-line
		});
	}
});
